import ui from './ui.module.css';
import { Link, useNavigate } from 'react-router';
import { InvitePaste } from '../landing/InvitePaste';
import { useAccountKey } from '../lib/account';
import { useOwnerJoinOffer } from '../lib/ownerJoin';
import { useCameraAvailable } from '../lib/qrScan';
import { useDeviceTokens } from '../lib/tokens';
import { useLauncherPage } from './hooks';
import { ChevronLeftIcon, ScanIcon } from './icons';
import styles from './JoinAnother.module.css';

/**
 * Route "/join" (no code) — join one more circle on this device: paste the invite link, scan its
 * QR code inside the installed launcher (a QR scanned with the Camera app opens Safari, whose
 * storage is not the Home Screen app's), or, with a builder key here, join the owner's own circles.
 */
export function JoinAnother() {
  useLauncherPage();
  const navigate = useNavigate();
  const camera = useCameraAvailable();
  const offer = useOwnerJoinOffer(useAccountKey());
  const hasCircles = Object.keys(useDeviceTokens()).length > 0;

  return (
    <main className={ui.page} data-testid="join-another">
      <Link to="/" className={styles.back}>
        <ChevronLeftIcon size={20} /> {hasCircles ? 'Your circles' : 'Bolt Circles'}
      </Link>
      <h1 className={ui.title}>Join {hasCircles ? 'another' : 'a'} circle</h1>
      <p className={ui.sub}>
        Paste the invite link you were sent, or scan its QR code. Each circle gets its own tab on this device.
      </p>

      {offer.circles.length > 0 && (
        <section className={styles.owner} data-testid="owner-join">
          <p className={styles.ownerText}>Your builder key is on this device, so you can join your own circles without a PIN.</p>
          <button
            className={ui.primary}
            disabled={offer.busy}
            onClick={() => void offer.join().then((ok) => ok && navigate('/', { replace: true }))}
          >
            {offer.busy ? 'Joining…' : offer.label}
          </button>
          {offer.error && <p className={styles.error}>{offer.error}</p>}
        </section>
      )}

      <section className={styles.card}>
        <InvitePaste />
        {camera && (
          <>
            <p className={styles.or}>or</p>
            <Link to="/join/scan" className={`${ui.secondary} ${styles.scan}`}>
              <ScanIcon /> Scan a QR code
            </Link>
          </>
        )}
      </section>
    </main>
  );
}
